module.exports = __webpack_public_path__ + "static/media/QR_Loading.92581f77.gif";